module.exports = __webpack_public_path__ + "static/media/terrier.e3efed00.png";